import { render, staticRenderFns } from "./mod6.vue?vue&type=template&id=dd2cc4da&scoped=true&"
import script from "./mod6.vue?vue&type=script&lang=js&"
export * from "./mod6.vue?vue&type=script&lang=js&"
import style0 from "./mod6.vue?vue&type=style&index=0&id=dd2cc4da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd2cc4da",
  null
  
)

export default component.exports